module.exports = new __parcel__URL__("desc_3.f0028942.png").toString();